export * from './src/ecom-v1-delivery-profile-delivery-profile.meta.js';
